import Login from '@auth/views/Login'
import { ROUTE_PARAM } from '@constants'
import { paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'
import React from 'react'

const LazySignup = React.lazy(() => import('@auth/views/Signup'))
const LazyEmailVerify = React.lazy(() => import('@auth/views/VerifyEmail'))
const LazyTransactionStatus = React.lazy(() => import('@transactions/views/TransactionStatus'))

// prettier-ignore
export const nonProtectedRoutes: RouteDefinition[] = [
  { path: paths.login(), component: Login },
  { path: paths.signUpViaInviteLink(ROUTE_PARAM.REFERRAL_CODE), component: LazySignup },
  { path: paths.signUp(), component: LazySignup },
  { path: paths.checkEmail(), component: React.lazy(() => import('@auth/views/VerifyEmailMessage')) },
  { path: paths.passwordReset(), component: React.lazy(() => import('@auth/views/ResetPasswordEmail')) },
  { path: paths.forgotPassword(), component: React.lazy(() => import('@auth/views/ForgotPassword')) },
  { path: paths.handleEmailVerify(), component: LazyEmailVerify },
  { path: paths.changePasswordEmail(), component: React.lazy(() => import('@auth/views/ForgotPasswordEmail')) },
  { path: paths.handlePasswordReset(), component: React.lazy(() => import('@auth/views/ResetPassword')) },
  { path: paths.handleInvitationVerify(), component: LazyEmailVerify },
  { path: paths.handlePasswordResetInvited(), component: React.lazy(() => import('@auth/views/SetPassword')) },
  { path: paths.invite(ROUTE_PARAM.LINK), component: React.lazy(() => import('@auth/views/Invite')) },

  {
    path: paths.invoices.checkout(ROUTE_PARAM.MAGIC_TOKEN),
    component: React.lazy(() => import('@invoices/views/InvoiceCheckout'))
  },
  {
    path: paths.invoices.viewByToken(ROUTE_PARAM.MAGIC_TOKEN),
    component: React.lazy(() => import('@invoices/views/InvoicePreviewByToken'))
  },

  {
    path: paths.banking.finalStatus.fail(ROUTE_PARAM.METHOD),
    component: LazyTransactionStatus,
    params: { isSuccess: false }
  },
  {
    path: paths.banking.finalStatus.success(ROUTE_PARAM.METHOD),
    component: LazyTransactionStatus,
    params: { isSuccess: true }
  }
]
